import PropTypes from "prop-types";
import { withTranslation } from "@template/components/translation";
import PricingRow from "../PricingRow";

const Total = ({ storeCode, text, formatTranslation }) => {
  if (storeCode !== "COM" || !text) {
    return null;
  }

  return (
    <PricingRow>
      <p>{formatTranslation("minibag_total_title")}</p>
      <div data-test-id="miniBagTotal">{text}</div>
    </PricingRow>
  );
};

Total.defaultProps = {
  text: null
};

Total.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  text: PropTypes.string,
  storeCode: PropTypes.string.isRequired
};

export default withTranslation(Total);
